(function () {
    const HEARTBEAT_URL = 'https://heartbeat-gwpjggroba-uc.a.run.app';
    const INTERVAL_MS = 10_000; // 10 seconds

    // Only run for logged-in customers
    const cust = window.shopifyCustomer;
    if (!cust || !cust.loggedIn) return;

    // Generate or reuse session ID (tab-scoped — clears when tab is closed)
    let sessionId = sessionStorage.getItem('ax_session_id');
    if (!sessionId) {
        sessionId = crypto.randomUUID();
        sessionStorage.setItem('ax_session_id', sessionId);
    }

    function lockSimulator(conflictData) {
        // Stop the physics loop from advancing the engine
        if (typeof isEngineRunning !== 'undefined') isEngineRunning = false;
        // Stop audio
        if (typeof audio !== 'undefined' && audio && typeof audio.stop === 'function') audio.stop();

        // Diagnostics — log lockout details without exposing the local session ID
        const activeId = conflictData?.activeSessionId ?? 'unknown';
        const reason   = conflictData?.reason         ?? 'CONFLICT';
        console.warn(
            '[AlphaX SessionGuard] Simulator locked.\n' +
            '  Reason:            ' + reason + '\n' +
            '  Active Session ID: ' + activeId + '\n' +
            '  Detected at:       ' + new Date().toISOString()
        );

        // Show the conflict overlay and surface the active session ID for support
        const overlay = document.getElementById('session-conflict-overlay');
        if (overlay) {
            overlay.classList.remove('hidden');
            overlay.style.display = 'flex';
            const idEl = document.getElementById('session-conflict-active-id');
            if (idEl) idEl.textContent = activeId;
        }
    }

    async function heartbeat() {
        try {
            const res = await fetch(HEARTBEAT_URL, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    customerId: cust.id,
                    email: cust.email,
                    sessionId,
                    secret: "AX_SECRET_GSP_2024",
                }),
            });
            const data = await res.json();
            if (data.status === 'CONFLICT') lockSimulator(data);
        } catch (_) {
            // Silent on network errors — don't lock out users for intermittent connectivity
        }
    }

    // Ping immediately on load, then every 10 seconds
    heartbeat();
    setInterval(heartbeat, INTERVAL_MS);
})();
